import { Sparkles, MessageSquare } from 'lucide-react';
import type { BuilderMode } from '../../types';

interface GuidedModeToggleProps {
  mode: BuilderMode;
  onModeChange: (mode: BuilderMode) => void;
}

export function GuidedModeToggle({ mode, onModeChange }: GuidedModeToggleProps) {
  return (
    <div className="flex w-full gap-2 p-1.5 border-b bg-muted/30 min-h-[41px]">
      <button
        onClick={() => onModeChange('guided')}
        className={`flex-1 flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium rounded-md transition-colors border ${
          mode === 'guided'
            ? 'bg-background text-foreground border-border shadow-sm'
            : 'bg-transparent text-muted-foreground border-transparent hover:text-foreground hover:bg-muted hover:border-border/50'
        }`}
      >
        <Sparkles className="h-4 w-4" />
        Guided
      </button>
      <button
        onClick={() => onModeChange('chat')}
        className={`flex-1 flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium rounded-md transition-colors border ${
          mode === 'chat'
            ? 'bg-background text-foreground border-border shadow-sm'
            : 'bg-transparent text-muted-foreground border-transparent hover:text-foreground hover:bg-muted hover:border-border/50'
        }`}
      >
        <MessageSquare className="h-4 w-4" />
        Chat
      </button>
    </div>
  );
}
